// import { Icon } from 'antd';

const POST = 'POST'
const GET = 'GET'

// export const breadcrumbSeparator = <Icon type="caret-right" />;

export const webPrefix = '/worksite'

export const method = { POST, GET }
